/* eslint-disable no-console */
import type {Analytics} from '@sail/observability';

const INITIALIZATION_WARNING_THRESHOLD = 10;

const accountInitializationCounts: Record<string, number> = {};

let hasEmittedAnalytics = false;

export function warnIfSameConnectedAccountInitializedManyTimes(
  accountId: string,
  analytics?: Analytics,
): void {
  accountInitializationCounts[accountId] =
    (accountInitializationCounts[accountId] ?? 0) + 1;

  if (
    accountInitializationCounts[accountId] === INITIALIZATION_WARNING_THRESHOLD
  ) {
    console.warn(
      "We've detected you initialized embedded components multiple times for the same account. Note this can slow down performance and increase resource usage in your website. You should call `loadConnectAndInitialize` only once per account in a given session. See our performance best practices https://docs.stripe.com/connect/get-started-connect-embedded-components?platform=web#performance-best-practices",
    );

    if (!hasEmittedAnalytics && analytics) {
      hasEmittedAnalytics = true;
      analytics.track(
        'submerchant_surfaces_repeated_initialization_warning_emitted',
      );
    }
  }
}
